import { AzuriaLogoLight } from "@brightdotai/digital-water-icons";
import { BackgroundImage, Button, Surface } from "@brightdotai/digital-water-ui";
import { Form, useSearchParams } from "react-router";
import { useT } from "@/i18n";

export default function Component() {
  let t = useT();

  const [searchParams] = useSearchParams();

  return (
    <div className={"min-h-svh"}>
      <BackgroundImage imagePath={"/assets/AegionBackground.jpg"} />
      <div className={"absolute w-[360px] top-1/3 left-1/2 -translate-x-1/2"}>
        <Surface className={"bg-[#44464f]"}>
          <div className={"h-[400px] flex flex-col p-4"}>
            <div className={"mx-auto"}>
              <AzuriaLogoLight large />
            </div>

            <div className={"grow flex flex-col self-center justify-center"}>
              <p
                className={
                  "dark:text-gray-dark-inverse-surface text-gray-light-inverse-surface"
                }
              >
                {t("portal:auth.logout.message")}
              </p>
            </div>

            <Form
              action={searchParams.get("test") ? "/auth/login/test" : "/auth/login"}
              method={"post"}
            >
              <Button
                data-testid={"login-button"}
                className={"w-full"}
                variant={"filled"}
                type={"submit"}
              >
                {t("common:auth.login.action")}
              </Button>
            </Form>
          </div>
        </Surface>
      </div>
    </div>
  );
}
